<template>
    <div class="expert-detail">
        <site-header></site-header>
        <div class="content-wrapper">
            <div class="expert-container">
                <div class="expert-header">
                    <div class="expert-title">{{ expertData.name }}</div>
                    <div v-if="expertData.position" class="expert-position">{{ expertData.position }}</div>
                    <div v-if="expertData.unit" class="expert-unit">{{ expertData.unit }}</div>
                </div>
                <div class="expert-content">
                    <div class="expert-image">
                        <img :src="expertData.photograph" :alt="expertData.name" />
                    </div>
                    <div class="expert-info">
                        <div v-if="expertData.introduce" class="expert-introduce" v-html="expertData.introduce"></div>
                        <!-- <div v-if="expertData.honor" class="expert-honor">
                            <h3>荣誉</h3>
                            <img :src="expertData.honor" :alt="expertData.name + '的荣誉'" class="honor-image" />
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <site-footer></site-footer>
    </div>
</template>

<script>
import siteHeader from "../components/SiteHeader.vue";
import siteFooter from "../components/SiteFooter.vue";

export default {
    name: "ExpertDetail",
    components: {
        siteHeader,
        siteFooter,
    },
    data() {
        return {
            expertData: {},
        };
    },
    created() {
        // Get expert data from route query
        const query = this.$route.query;
        if (query.data) {
            // 处理从 Volume.vue 传来的 JSON 字符串数据
            const responseData = JSON.parse(query.data);
            if (responseData.rows && responseData.rows.length > 0) {
                this.expertData = responseData.rows[0];
            }
        } else if (query.specialist || query.teacher) {
            // 处理从 Home.vue 传来的直接数据
            this.expertData = query.specialist || query.teacher;
        }
    },
};
</script>

<style scoped>
.expert-detail {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #fafbfc;
}

.content-wrapper {
    flex: 1;
    padding: 40px 20px;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
}

.expert-container {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    padding: 40px;
}

.expert-header {
    text-align: center;
    margin-bottom: 40px;
}

.expert-title {
    font-size: 32px;
    color: #2d437c;
    font-weight: 600;
    margin-bottom: 16px;
}

.expert-position {
    font-size: 18px;
    color: #666;
    margin-bottom: 8px;
}

.expert-unit {
    font-size: 16px;
    color: #888;
}

.expert-content {
    display: flex;
    gap: 40px;
}

.expert-image {
    flex: 0 0 300px;
}

.expert-image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.expert-info {
    flex: 1;
}

.expert-introduce {
    font-size: 16px;
    line-height: 1.8;
    color: #333;
    margin-bottom: 30px;
}

.expert-honor {
    margin-top: 30px;
}

.expert-honor h3 {
    font-size: 20px;
    color: #2d437c;
    margin-bottom: 16px;
}

.honor-image {
    width: 60%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: block;
    margin: 0 auto;
}

/* Deep selectors for rich text content */
:deep(.expert-introduce p) {
    margin-bottom: 16px;
}

:deep(.expert-introduce a) {
    color: #136ec2;
    text-decoration: none;
}

:deep(.expert-introduce a:hover) {
    text-decoration: underline;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .content-wrapper {
        padding: 20px 15px;
    }

    .expert-container {
        padding: 25px 20px;
        border-radius: 8px;
    }

    .expert-header {
        margin-bottom: 25px;
    }

    .expert-title {
        font-size: 24px;
        margin-bottom: 12px;
    }

    .expert-position {
        font-size: 16px;
        margin-bottom: 6px;
    }

    .expert-unit {
        font-size: 14px;
    }

    .expert-content {
        flex-direction: column;
        gap: 25px;
    }

    .expert-image {
        flex: none;
        width: 100%;
    }

    .expert-image img {
        max-width: 100%;
        height: auto;
    }

    .expert-info {
        width: 100%;
    }

    .expert-introduce {
        font-size: 15px;
        line-height: 1.7;
        margin-bottom: 25px;
    }

    .expert-honor {
        margin-top: 25px;
    }

    .expert-honor h3 {
        font-size: 18px;
        margin-bottom: 12px;
    }

    .honor-image {
        width: 100%;
        max-width: 100%;
    }
}

@media screen and (max-width: 480px) {
    .content-wrapper {
        padding: 15px 10px;
    }

    .expert-container {
        padding: 20px 15px;
    }

    .expert-header {
        margin-bottom: 20px;
    }

    .expert-title {
        font-size: 20px;
        margin-bottom: 10px;
    }

    .expert-position {
        font-size: 15px;
    }

    .expert-unit {
        font-size: 13px;
    }

    .expert-content {
        gap: 20px;
    }

    .expert-introduce {
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 20px;
    }

    .expert-honor h3 {
        font-size: 16px;
        margin-bottom: 10px;
    }
}
</style>